<template>
    <div
        class="_direction-container"
        ref="directions"
        :class="darkMode ? 'dark-mode' : ''"
    >
        <div class="_direction-logo" :class="darkMode ? 'dark-mode' : ''">
            <picture class="logo header-buttons__logo">
                <source
                    srcset="
                        /static/dist/land-v2/img/logo-DOM-RF-land-mobile.svg
                    "
                    media="(max-width: 767px)"
                />
                <img
                    src="/static/dist/land-v2/img/logo-DOM-RF-land.svg"
                    alt="ДОМ РФ Земля"
                    loading="lazy"
                />
            </picture>
            <div
                class="_direction-close-btn"
                :class="darkMode ? 'dark-mode' : ''"
                @click="closePopUp"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="39"
                        height="39"
                        rx="19.5"
                        stroke="#252628"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.6669 14.6667C14.9273 14.4063 15.3494 14.4063 15.6098 14.6667L19.8525 18.9094L24.095 14.6669C24.3554 14.4065 24.7775 14.4065 25.0378 14.6669C25.2982 14.9272 25.2982 15.3494 25.0378 15.6097L20.7953 19.8522L25.0378 24.0948C25.2982 24.3551 25.2982 24.7772 25.0378 25.0376C24.7775 25.2979 24.3554 25.2979 24.095 25.0376L19.8525 20.7951L15.6098 25.0378C15.3494 25.2981 14.9273 25.2981 14.6669 25.0378C14.4066 24.7774 14.4066 24.3553 14.6669 24.095L18.9097 19.8522L14.6669 15.6095C14.4066 15.3492 14.4066 14.927 14.6669 14.6667Z"
                        fill="#252628"
                    />
                </svg>
            </div>
        </div>
        <div
            class="_internal-list-container"
            :class="darkMode ? 'dark-mode' : ''"
        >
            <div class="_internal-list">
                <div
                    class="_internal-list__item"
                    v-for="direction in directions"
                    :key="direction"
                >
                    <div class="_internal-list__link">
                        <img
                            class="_internal-list__icon"
                            :src="direction.img"
                            :alt="direction.name"
                            :title="direction.name"
                            loading="lazy"
                            width="48"
                            height="48"
                        />
                        <div>
                            <h4
                                class="_internal-list__title"
                                :class="darkMode ? 'dark-mode' : ''"
                                :title="direction.name"
                            >
                                {{ direction.name }}
                            </h4>
                            <span
                                class="_internal-list__desc"
                                v-html="direction.desc"
                            ></span>
                        </div>
                        <a
                            class="_link-full-block"
                            :href="direction.url"
                            :target="direction._blank === 'Y' ? '_blank' : ''"
                            :title="direction.name"
                        ></a>
                    </div>
                    <div class="_internal-list-socials">
                        <a
                            v-for="social in direction.items"
                            :key="social"
                            :href="social.url"
                            class="_internal-list-socials__item"
                            :target="social._blank === 'Y' ? '_blank' : ''"
                            :title="social.name"
                        >
                            <img
                                :src="`/static/dist/land-v2/img/socials/${social.soc}.svg`"
                                :alt="social.name"
                                class=""
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';

// Props с корректным TypeScript интерфейсом
const props = defineProps({
    directions: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const emit = defineEmits(['change', 'delete']);

const closePopUp = () => {
    emit('closePanel');
};
</script>
